import { BodyContainer } from "App/styles";
import { MainTitle } from "components/MainTitle";
import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { DescriptionContainer } from "./styles";
import storyUrl from "../../data/story.md?url";

export default function AwardStory() {
  const [text, setText] = useState("");

  useEffect(() => {
    fetch(storyUrl)
      .then((res) => res.text())
      .then((res) => setText(res))
      .catch((err) => console.log(err));
  });

  return (
    <BodyContainer>
      <MainTitle title="Historia" seoTitle="Historia" />
      <DescriptionContainer>
        <ReactMarkdown>{text}</ReactMarkdown>
      </DescriptionContainer>
    </BodyContainer>
  );
}
